<template>
  <router-view v-if="brandConfig"/>
</template>

<script>
import {mapState} from "vuex";
import {setBrandConfig} from "@/functions/setBrandConfig";
import {resolveLanguage, setLanguage} from "@/functions/setLanguage";
import {readMsisdnFromUrl} from "@/functions/readMsisdnFromUrl";
import addGTM from "@/functions/addGTM";

export default {
  computed: {
    ...mapState(['brandConfig'])
  },
  beforeMount() {
    setBrandConfig();
    setLanguage(resolveLanguage());

    const msisdn = readMsisdnFromUrl();
    if (msisdn) this.$store.commit('setMsisdn', msisdn);

    this.setTabName();
    this.setFavicon();
    if (this.brandConfig.gtmIdentifier) addGTM(this.brandConfig.gtmIdentifier);
  },
  methods: {
    setTabName() {
      document.title = this.brandConfig.tabTitle;
    },
    setFavicon() {
      this.$nextTick(() => {
        const assetBrand = this.brandConfig.assetBrand || this.brandConfig.brand;
        const faviconPath = require(`@/brand/${assetBrand}/assets/favicon.png`);

        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = faviconPath;

        if (!link.parentNode) document.head.appendChild(link);
      });
    }
  }
}
</script>
